import React from 'react';
import parse from 'html-react-parser';

export interface IHTMLParserProps {
  rawHtml: string;
}

export default function HTMLParser({ rawHtml }: IHTMLParserProps) {
  return rawHtml ? <>{parse(rawHtml)}</> : null;
}
